/* eslint-disable no-console */
import React from 'react';
import { FieldSet, Filter, FiltersWrapper, OptionToggle, OptionsToggle, StyledButton, StyledExpandable, FilterIcon, ArrowIcon, FiltersVisualization, GameType, RemainingFilters } from './styles';
import FormInput from 'components/ui/v2/Inputs';
import { StyledDropdown } from '../styles';
import { useAdminTranslation } from 'hooks/use-translation';
import { IBlockRegion, SEASON_DROPDOWN_OPTIONS } from '../utils';
import useToggle from 'hooks/use-toggle';

// tslint:disable-next-line: no-empty
const NO_OP = () => {};

type FilterProps = {
  isRanked: boolean;
  region: IBlockRegion;
};

const CommonFilters: React.FC<{ isRanked: boolean; }> = ({ isRanked }) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <Filter flex={1}>
        <FormInput.Label>{t('GAME_TYPE')}</FormInput.Label>
        <OptionsToggle>
          <OptionToggle active={true}>{t('BATTLE_ROYALE')}</OptionToggle>
          <OptionToggle active={false}>{t('ZERO_BUILD')}</OptionToggle>
        </OptionsToggle>
      </Filter>

      <Filter>
        <FormInput.Label>{t('SEASON')}</FormInput.Label>
        <StyledDropdown
          isAdmin={false}
          padding="0"
          onChange={NO_OP}
          options={SEASON_DROPDOWN_OPTIONS}
          value={SEASON_DROPDOWN_OPTIONS[0]}
        />
      </Filter>

      {
        !isRanked && (
          <>
            <Filter>
              <FormInput.Label>{t('TOURNAMENT')}</FormInput.Label>
              <StyledDropdown
                isAdmin={false}
                padding="0"
                onChange={NO_OP}
                options={[
                  {
                    label: 'Solos Cash Cup',
                    value: 'solosCashCup',
                  },
                ]}
              />
            </Filter>

            <Filter>
              <FormInput.Label>{t('SESSION')}</FormInput.Label>
              <StyledDropdown
                isAdmin={false}
                padding="0"
                onChange={NO_OP}
                options={[
                  {
                    label: 'Event 2 Round 1',
                    value: 'event2Round1',
                  },
                ]}
              />
            </Filter>
          </>
        )
      }
    </>
  );
};

const Filters: React.FC<FilterProps> = ({ region, isRanked }) => {
  const { t } = useAdminTranslation();
  const [isExpanded, toggle] = useToggle(false);

  return (
    <>
      <FiltersWrapper gap={20}>
        {region === 'landingPageBlock' && <CommonFilters isRanked={isRanked} />}

        <FiltersWrapper gap={8} style={{ flex: 1 }}>
          {
            region === 'panel' && (
              <StyledButton onClick={toggle}>
                <FilterIcon />
                {t('FILTERS')}
                <ArrowIcon name={isExpanded ? 'arrowDropDownUp' : 'arrowDropDownDown'} />
              </StyledButton>
            )
          }

          <Filter flex={1}>
            {region === 'landingPageBlock' && (<FormInput.Label>{t('ICON_NAME_SEARCH')}</FormInput.Label>)}
            <FieldSet>
              <FormInput.InputIcon name="search" />
              <FormInput.TextInput
                placeholder={t('SEARCH_BY_NAME')}
              />
            </FieldSet>
          </Filter>
        </FiltersWrapper>

        <StyledExpandable isExpanded={isExpanded}>
          <CommonFilters isRanked={isRanked} />
        </StyledExpandable>
      </FiltersWrapper>
      {region === 'panel' && (
        <FiltersVisualization>
          <GameType>Battle Royale</GameType>
          <RemainingFilters>{'Chapter 5 Season 1 -> Solo Mode'}</RemainingFilters>
        </FiltersVisualization>
      )}
    </>
  );
};

export default Filters;
